import * as Yup from 'yup'


export function ValidateLogin(values) {
    return Yup.object().shape({
        email: Yup.string().email('Please enter a valid email').required('This field is required'),
        password: Yup.string().required('This field is required'),
    });
}

export function ValidateReset(values) {
    return Yup.object().shape({
        email: Yup.string().email('Please enter a valid email').required('This field is required'),
    });
}

export function ValidateNewPassword(values) {
    return Yup.object().shape({
        password: Yup.string().required('This field is required').min(6, 'Password should be 6 chars minimum.'),
    });
}
